import { render } from "./AdvertisingList.vue?vue&type=template&id=67a3b260&scoped=true"
import script from "./AdvertisingList.vue?vue&type=script&lang=js"
export * from "./AdvertisingList.vue?vue&type=script&lang=js"

import "./AdvertisingList.vue?vue&type=style&index=0&id=67a3b260&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a3b260"]])

export default __exports__